import { NgIf, NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from "@angular/core";
import { NzCardMetaComponent } from "ng-zorro-antd/card";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";

@Component({
  selector: "ui-card-meta",
  exportAs: "uiCardMeta",
  templateUrl: "card-meta.component.html",
  styleUrl: "card-meta.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgTemplateOutlet, NzOutletModule],
})
export class UiCardMetaComponent extends NzCardMetaComponent {
  @Input("uiTitle") public nzTitle: string | TemplateRef<void> | null = null;
  @Input("uiDescription") public nzDescription: string | TemplateRef<void> | null = null;
  @Input("uiAvatar") public nzAvatar: TemplateRef<void> | null = null;
}
